import React, { useState, useEffect } from 'react';
import { getPolicies } from './../../../services/policy';
import { LocalPersistence } from "./../../../factories/index";
import { sessionType } from './../../../interfaces/index';
import Loading from './../../Loading';
import GeneralTab from './components/General/GeneralTab';
import CancellationTab from './components/Cancellation/CancellationTab';
import ADDCancellation from './components/Cancellation/AddCancellation';
import GPAdd from './components/GuaranteePayment/GPAdd';
import GPDetails from './components/GuaranteePayment/GPDetails';
import TaxesAdd from './components/Taxes/TaxesAdd';
import TaxesDetails from './components/Taxes/TaxesDetails';
import PetsDetail from './components/Pets/PetsDetail';
import PetsEdit from './components/Pets/PetsEdit';
import PetsAdd from './components/Pets/PetsAdd';
import { message } from 'antd';
import FeesDetail from './components/Fees/FeesDetail';
import FeesEdit from './components/Fees/FeesEdit';
import FeesAdd from './components/Fees/FeesAdd';
import OtherPoliciesDetail from './components/OtherPolicies/OtherPoliciesDetail';
import OtherPoliciesEdit from './components/OtherPolicies/OtherPoliciesEdit';
import OtherPoliciesAdd from './components/OtherPolicies/OtherPoliciesAdd';

interface propsTypes {
    isEditable: void | any,
    cancelEditable: void | any
}

const addDetails = {

    valueList: [
        { title: 'Mon', label: 'monday', value: true },
        { title: 'Tue', label: 'tuesday', value: true },
        { title: 'Wed', label: 'wednesday', value: true },
        { title: 'Thu', label: 'thursday', value: true },
        { title: 'Fri', label: 'friday', value: true },
        { title: 'Sat', label: 'saturday', value: true },
        { title: 'Sun', label: 'sunday', value: true },
    ]


}

let supplier: string
let propertyId: string
const EnvironmentalImpact = (props: propsTypes) => {
    const [operationType, setOperationType] = useState('view')
    const [activeTabKey, setActiveTabKey] = useState('General')
    const [policiesData, setPoliciesData] = useState<any>(null)
    const [cancellationDetails, setCancellationDetails] = useState(null)
    const [feesDetails, setFeesDetails] = useState(null)
    const [petsDetails, setPetsDetails] = useState(null)

    const [otherPoliciesDetails, setOtherPoliciesDetails] = useState(null)
    const [RatesDetails, setRatesDetails] = useState<Object | null>(null)
    const [petsAllowType, setPetsAllowType] = useState('')
    const changeTab = (key: string) => {
        setActiveTabKey(key)
    }

    const getPoliciesData = async (tabKey?: string) => {
        setPoliciesData(null)
        tabKey && setActiveTabKey(tabKey)
        const get_session = new LocalPersistence('session')
        const session: sessionType = await get_session.getSessionPersistence()

        supplier = session.supplier
        propertyId = session.propertyId
        getPolicies(supplier, propertyId).then(response => {
            if (response.result.success) {
                if(!response.property.policies.checkoutcharge.length){
                  response.property.policies.checkoutcharge=[{}]
                }
                if(!response.property.policies.staypolicy.policies.length){
                  response.property.policies.staypolicy.policies=[{}]
                }
                setPoliciesData(response?.property)
                setPetsAllowType(response?.property?.policies?.general?.petsallowed)
            } else {
                message.error({
                    content: response?.error[0]?.message
                });
                setPoliciesData({})
            }
            //setPoliciesData(mockData.property)
            //setPetsAllowType(mockData?.property?.policies?.general?.pets)
        }, err => {
            message.error({
                content: err?.message || err?.error[0]?.message
            });
            setPoliciesData({})
            // setPoliciesData(mockData.property)
            // setPetsAllowType(mockData?.property?.policies?.general?.pets)
        })
    }


    useEffect(() => {
        getPoliciesData()
    }, [activeTabKey])

    const mainTabs = <GeneralTab
        activeTabKey={activeTabKey}
        changeTab={changeTab}
        operationType={operationType}
        setOperationType={setOperationType}
        isEditable={props.isEditable}
        cancelEditable={props.cancelEditable}
        policiesData={policiesData}
        getPoliciesData={getPoliciesData}
        setPoliciesData={setPoliciesData}
        setCancellationDetails={setCancellationDetails}
        setFeesDetails={setFeesDetails}
        setPetsDetails={setPetsDetails}
        setOtherPoliciesDetails={setOtherPoliciesDetails}
        petsAllowType={petsAllowType}
        setPetsAllowType={setPetsAllowType}
        setRatesDetails={setRatesDetails}
    />

    const renderTabs = () => {
        switch (activeTabKey) {
            case 'General':
                return mainTabs;
            case 'Cancellation':
                return mainTabs;
            case 'CancellationDetails':
                return <CancellationTab
                    cancellationDetails={cancellationDetails}
                    setOperationType={setOperationType}
                    setActiveTabKey={setActiveTabKey}
                    isEditable={props.isEditable}
                    cancelEditable={props.cancelEditable}
                    supplier={supplier}
                    propertyId={propertyId}
                    getPoliciesData={getPoliciesData}
                    setPoliciesData={setPoliciesData}
                />
            case 'ADDCancellation':
                return <ADDCancellation
                    cancellationDetails={addDetails}
                    setOperationType={setActiveTabKey}
                    isEditable={props.isEditable}
                    cancelEditable={props.cancelEditable}
                    setActiveTabKey={setActiveTabKey}
                    supplier={supplier}
                    propertyId={propertyId}
                    getPoliciesData={getPoliciesData}
                    setPoliciesData={setPoliciesData}
                />
            case 'CheckOutCharge':
                return mainTabs;
            case 'Commission':
                return mainTabs;
            case 'Extra Charge':
                return mainTabs;
            case 'Fees':
                return mainTabs;
            case 'Pets':
                return mainTabs;
            case 'PetsDetails':
                return <PetsDetail
                    petsDetails={petsDetails}
                    isEditable={props.isEditable}
                    changeTab={changeTab} />
            case 'PetsEdit':
                return <PetsEdit
                    petsDetails={petsDetails}
                    isEditable={props.isEditable}
                    cancelEditable={props.cancelEditable}
                    supplier={supplier}
                    propertyId={propertyId}
                    changeTab={changeTab}
                    getPoliciesData={getPoliciesData}
                    setPoliciesData={setPoliciesData}
                    setPetsDetails={setPetsDetails}
                />

            case 'FeesDetails':
                return <FeesDetail
                    feesDetails={feesDetails}
                    isEditable={props.isEditable}
                    changeTab={changeTab}
                />
            case 'FeesEdit':
                return <FeesEdit
                    feesDetails={feesDetails}
                    isEditable={props.isEditable}
                    cancelEditable={props.cancelEditable}
                    supplier={supplier}
                    propertyId={propertyId}
                    changeTab={changeTab}
                    getPoliciesData={getPoliciesData}
                    setPoliciesData={setPoliciesData}
                    setFeesDetails={setFeesDetails}
                />
            case 'FeesAdd':
                return <FeesAdd
                    feesDetails={feesDetails}
                    isEditable={props.isEditable}
                    cancelEditable={props.cancelEditable}
                    supplier={supplier}
                    propertyId={propertyId}
                    changeTab={changeTab}
                    getPoliciesData={getPoliciesData}
                    setPoliciesData={setPoliciesData}
                    setFeesDetails={setFeesDetails}
                />
            case 'PetsAdd':
                return <PetsAdd
                    petsDetails={petsDetails}
                    isEditable={props.isEditable}
                    cancelEditable={props.cancelEditable}
                    supplier={supplier}
                    propertyId={propertyId}
                    changeTab={changeTab}
                    getPoliciesData={getPoliciesData}
                    setPoliciesData={setPoliciesData}
                    setPetsDetails={setPetsDetails}
                />
            case 'MinAndMaxStay':
              return mainTabs;
            case 'OtherPolicies':
                return mainTabs;
            case 'OtherPoliciesDetails':
                return <OtherPoliciesDetail
                    otherPoliciesDetails={otherPoliciesDetails}
                    isEditable={props.isEditable}
                    changeTab={changeTab}
                />
            case 'OtherPoliciesEdit':
                return <OtherPoliciesEdit
                    otherPoliciesDetails={otherPoliciesDetails}
                    isEditable={props.isEditable}
                    cancelEditable={props.cancelEditable}
                    supplier={supplier}
                    propertyId={propertyId}
                    changeTab={changeTab}
                    getPoliciesData={getPoliciesData}
                    setPoliciesData={setPoliciesData}
                    setOtherPoliciesDetails={setOtherPoliciesDetails}
                />
            case 'OtherPoliciesAdd':
                return <OtherPoliciesAdd
                    otherPoliciesDetails={otherPoliciesDetails}
                    isEditable={props.isEditable}
                    cancelEditable={props.cancelEditable}
                    supplier={supplier}
                    propertyId={propertyId}
                    changeTab={changeTab}
                    getPoliciesData={getPoliciesData}
                    setPoliciesData={setPoliciesData}
                    setOtherPoliciesDetails={setOtherPoliciesDetails}
                />
            case 'GuaranteePayment':
                return mainTabs;
            case 'GuaranteePaymentAdd':
                return <GPAdd cancellationDetails={addDetails}
                    setOperationType={setActiveTabKey}
                    isEditable={props.isEditable}
                    cancelEditable={props.cancelEditable}
                    setActiveTabKey={setActiveTabKey}
                    getPoliciesData={getPoliciesData} />
            case 'GuaranteePaymentDetail':
                return <GPDetails 
                        cancellationDetails={cancellationDetails} 
                        isEditable={props.isEditable}
                        cancelEditable={props.cancelEditable} 
                        setActiveTabKey={setActiveTabKey} 
                        changeTab={changeTab}
                        getPoliciesData={getPoliciesData} />
            case 'Taxes':
                return mainTabs;
            case 'TaxesAdd':
                return <TaxesAdd cancellationDetails={addDetails}
                    setOperationType={setActiveTabKey}
                    isEditable={props.isEditable}
                    cancelEditable={props.cancelEditable}
                    setActiveTabKey={setActiveTabKey}
                    getPoliciesData={getPoliciesData} />
            case 'TaxesDetail':
                return <TaxesDetails cancellationDetails={cancellationDetails} isEditable={props.isEditable}
                    cancelEditable={props.cancelEditable} setActiveTabKey={setActiveTabKey} getPoliciesData={getPoliciesData} />
            case 'Rates':
                return mainTabs;
            default: return null
        }

    }

    return (
        <>
            {
                policiesData ? renderTabs() : <Loading type='large' />
            }
        </>
    )
}

export default EnvironmentalImpact;

